module.exports = __webpack_public_path__ + "img/13.8f148df3.png";